import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, Calendar, MapPin, Mail } from 'lucide-react';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full">
        <CardContent className="p-8 text-center">
          {/* Success Icon */}
          <div className="mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>

          {/* Thank You Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Thank You for Registering!
          </h1>
          
          <p className="text-xl text-[#05ab95] font-semibold mb-6">
            AURA 2026
          </p>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-8">
            <p className="text-green-800 font-medium">
              ✅ Your payment has been received successfully
            </p>
            <p className="text-green-700 text-sm mt-1">
              A confirmation email will be sent to your registered email address shortly.
            </p>
          </div>

          {/* Conference Details */}
          <div className="bg-gray-100 rounded-lg p-6 mb-8 text-left">
            <h2 className="font-semibold text-gray-900 mb-4 text-center">Conference Details</h2>
            <div className="space-y-3">
              <div className="flex items-center text-gray-700">
                <Calendar className="w-5 h-5 text-[#05ab95] mr-3" />
                <span><strong>Date:</strong> April 4-5, 2026</span>
              </div>
              <div className="flex items-center text-gray-700">
                <MapPin className="w-5 h-5 text-[#05ab95] mr-3" />
                <span><strong>Location:</strong> Dubai, UAE</span>
              </div>
              <div className="flex items-center text-gray-700">
                <Mail className="w-5 h-5 text-[#05ab95] mr-3" />
                <span><strong>Contact:</strong> auraconferences@gmail.com</span>
              </div>
            </div>
          </div>

          {/* What's Next */}
          <div className="text-left mb-8">
            <h3 className="font-semibold text-gray-900 mb-3">What's Next?</h3>
            <ul className="text-gray-600 space-y-2 text-sm">
              <li>• You will receive a confirmation email with your registration details</li>
              <li>• The complete conference program will be shared 4 weeks before the event</li>
              <li>• Certificate of attendance will be provided after the conference</li>
            </ul>
          </div>

          {/* Back to Home */}
          <Button 
            onClick={() => window.location.href = '/'}
            className="bg-[#05ab95] hover:bg-[#048c7a] text-white px-8 py-6 text-lg"
          >
            Back to Home
          </Button>

          <p className="text-gray-500 text-sm mt-6">
            If you have any questions, please contact us at{' '}
            <a href="mailto:auraconferences@gmail.com" className="text-[#05ab95] hover:underline">
              auraconferences@gmail.com
            </a>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
